"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetCircle = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _paulCorePackage = require("paul-core-package");
var _react = require("react");
var animationTemperatureRed = _interopRequireWildcard(require("../images/animation/fluid_lottie_red.json"));
var animationTemperatureBlue = _interopRequireWildcard(require("../images/animation/fluid_lottie_blue.json"));
var animationPower = _interopRequireWildcard(require("../images/animation/Animation_Kreis_gruen.json"));
var animationFlow = _interopRequireWildcard(require("../images/animation/wave_animation.json"));
var _constants = require("../utils/constants");
var _useGetValue = require("./useGetValue");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const useGetCircle = _ref => {
  let {
    type = _constants.circleType.temperature,
    displayNameId,
    thingPDIDDevice
  } = _ref;
  const timeout = (0, _react.useRef)(null);
  const [firstCircle, setFirstCircle] = (0, _react.useState)();
  const [secondCircle, setSecondCircle] = (0, _react.useState)();
  const [hasValue, setHasValue] = (0, _react.useState)(false);
  const [transition, setTransition] = (0, _react.useState)('');
  const [showDefault, setShowDefault] = (0, _react.useState)(false);
  const [temperatureStatus = {}, value] = (0, _useGetValue.useGetValueParamsByDisplayNameId)({
    displayNameId,
    thingPDIDDevice,
    params: [_constants.valueParamsName.temperatureStatus, _constants.valueParamsName.value]
  });
  (0, _react.useEffect)(() => {
    const _hasValue = value !== null && value !== undefined;
    setHasValue(_hasValue);
    if (type === _constants.circleType.power) setShowDefault(!_hasValue || +value <= 0);
  }, [value]);
  (0, _react.useEffect)(() => {
    if (type === _constants.circleType.temperature) setShowDefault((temperatureStatus === null || temperatureStatus === void 0 ? void 0 : temperatureStatus.statusColor) === _paulCorePackage.constants.colorStatus.oldData);
    // else if(type === circleType.power) setShowDefault(!hasValue)
    // else if(type === circleType.flow) // not needed
  }, [type, temperatureStatus === null || temperatureStatus === void 0 ? void 0 : temperatureStatus.statusColor, hasValue]);
  (0, _react.useEffect)(() => {
    if (transition) {
      clearTimeout(timeout.current);
      timeout.current = setTimeout(() => {
        if (firstCircle && secondCircle) {
          if (transition === _constants.circles.first) {
            setFirstCircle(null);
          } else {
            setSecondCircle(null);
          }
        }
      }, 3100);
    }
  }, [transition, firstCircle, secondCircle]);
  const getAnimationData = (0, _react.useCallback)(() => {
    if (type === _constants.circleType.temperature) {
      return temperatureStatus.statusColor === _paulCorePackage.constants.colorStatus.wrongData || temperatureStatus.statusColor === _paulCorePackage.constants.colorStatus.isLow || temperatureStatus.statusColor === _paulCorePackage.constants.colorStatus.isHigh ? animationTemperatureRed : temperatureStatus.statusColor === _paulCorePackage.constants.colorStatus.optimal ? animationTemperatureBlue : null;
    }
    if (type === _constants.circleType.power) {
      return animationPower;
    }
    if (type === _constants.circleType.flow) {
      return animationFlow;
    }
  }, [type, temperatureStatus.statusColor]);
  const setCircleUpdate = (0, _react.useCallback)(() => {
    const animationData = getAnimationData();
    if (firstCircle === null) {
      setFirstCircle(animationData);
      setTransition(_constants.circles.second);
    } else {
      setSecondCircle(animationData);
      setTransition(_constants.circles.first);
    }
  }, [firstCircle, temperatureStatus, getAnimationData]);
  (0, _react.useEffect)(() => {
    if (!firstCircle || !secondCircle) {
      if (type === _constants.circleType.temperature && temperatureStatus) setCircleUpdate();else if (type === _constants.circleType.power && hasValue) setCircleUpdate();else if (type === _constants.circleType.flow && hasValue) setCircleUpdate();
    }
  }, [firstCircle, secondCircle, setCircleUpdate, temperatureStatus, type, hasValue]);
  (0, _react.useEffect)(() => {
    if (type === _constants.circleType.temperature && temperatureStatus) setCircleUpdate();else if (type === _constants.circleType.power && hasValue) setCircleUpdate();else if (type === _constants.circleType.flow && hasValue) setCircleUpdate();
  }, [temperatureStatus, setCircleUpdate, type, hasValue]);
  return {
    firstCircle,
    secondCircle,
    transition,
    showDefault
  };
};
exports.useGetCircle = useGetCircle;